import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, BookmarkIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const tools = [
  {
    title: 'Team Charter Template',
    description: 'A Miro template to help you create a team charter that defines your team\'s purpose, values, and boundaries.',
    url: 'https://miro.com/templates/team-charter/'
  }
];

const additional = [
  {
    title: 'Maker\'s Schedule, Manager\'s Schedule',
    description: 'Paul Graham\'s essay on the different types of schedules and how they affect productivity.',
    url: 'https://paulgraham.com/makersschedule.html'
  },
  {
    title: 'Are you a giver or a taker?',
    description: 'Adam Grant\'s TED talk on the dynamics of giving and taking in the workplace.',
    url: 'https://www.ted.com/talks/adam_grant_are_you_a_giver_or_a_taker?language=en'
  }
];

const SettingBoundariesUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Tools & Templates" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Additional Resources" 
            items={additional} 
            icon={BookmarkIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default SettingBoundariesUsefulResources; 